var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.0001C26 12.1833 25.9234 11.3658 25.7716 10.572C25.7032 10.2128 25.3885 9.95312 25.0233 9.95312H13.0508C12.6298 9.95312 12.2891 10.2938 12.2891 10.7148V15.2852C12.2891 15.7062 12.6298 16.0469 13.0508 16.0469H19.1936C18.8109 16.8217 18.2834 17.494 17.6641 18.0596L21.9693 22.3648C24.4464 20.0048 26 16.6837 26 13.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.09375C14.4945 6.09375 15.916 6.56835 17.1106 7.46693C17.4126 7.69382 17.8389 7.66629 18.1066 7.39624L21.3573 4.14553C21.5084 3.9945 21.5894 3.78696 21.5798 3.57348C21.5701 3.35999 21.4719 3.16063 21.3082 3.02301C18.9822 1.07341 16.0313 0 13 0C8.53894 0 4.59786 2.26759 2.26807 5.71045L6.73925 10.1816C7.80596 7.77888 10.206 6.09375 13 6.09375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C15.9079 26 18.5856 25.025 20.7493 23.4007L16.3633 19.0146C15.3608 19.5791 14.215 19.9062 13 19.9062C10.206 19.9062 7.80596 18.2211 6.73925 15.8184L2.26807 20.2895C4.59786 23.7324 8.53894 26 13 26Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20466 14.097C6.14631 13.7376 6.09375 13.3755 6.09375 12.9999C6.09375 12.6243 6.14631 12.2623 6.20466 11.9028L1.42492 7.12305C0.520609 8.88922 0 10.8831 0 12.9999C0 15.1167 0.520609 17.1106 1.42497 18.8767L6.20466 14.097Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.033f74ce74ae615f73cd99c84e034b06.svg";
export { ForwardRef as ReactComponent };